// Mapeamento de lojas para UF
export const storeUFMap = {
  1: "MT", 2: "MT", 3: "MT", 4: "GO", 5: "MT", 6: "MT", 7: "MT", 8: "MT", 9: "MT", 10: "ES",
  11: "MT", 12: "MS", 13: "PA", 14: "MS", 15: "ES", 16: "PA", 17: "MT", 18: "ES", 19: "PA",
  20: "MT", 21: "GO", 22: "MT", 23: "PA", 24: "MS", 25: "RO", 26: "ES", 27: "RO", 28: "MT",
  29: "MS", 30: "MS", 31: "MT", 32: "MS", 33: "GO", 34: "TO", 35: "MG", 36: "PA", 37: "MT",
  38: "GO", 39: "MT", 40: "BA", 41: "MS", 42: "RO", 43: "MT", 44: "MT", 45: "ES", 46: "GO",
  47: "RO", 48: "RO", 49: "MT", 50: "MT", 51: "AC", 52: "GO", 53: "MT", 54: "GO", 55: "MT",
  56: "GO", 57: "RO", 58: "MT", 59: "ES", 60: "GO", 61: "RO", 62: "TO", 63: "ES", 64: "MT",
  65: "ES", 66: "ES", 67: "BA", 68: "MS", 69: "MS", 70: "MG", 71: "GO", 72: "GO", 73: "RO",
  74: "RO", 75: "MT", 76: "TO", 77: "MA", 78: "TO", 79: "TO", 80: "PA", 81: "PA", 82: "ES",
  83: "BA", 84: "MS", 85: "TO", 86: "MT", 87: "MT", 88: "MT", 89: "MT", 90: "MS", 91: "GO",
  92: "GO", 93: "MA", 94: "PA", 95: "PA", 96: "TO", 97: "AC", 98: "GO", 99: "BA", 100: "MS",
  101: "MS", 102: "MS", 103: "TO", 104: "BA", 105: "GO", 106: "GO", 107: "MS", 108: "PA",
  109: "ES", 110: "GO", 111: "MT", 112: "MS", 113: "MG", 114: "MT", 115: "PA", 116: "PA",
  117: "MT", 118: "ES", 119: "PA", 120: "PA", 121: "PA", 122: "PA", 123: "GO", 124: "GO",
  125: "MA", 126: "RO", 127: "MA", 128: "PA", 129: "MT", 130: "MS", 131: "RO", 132: "MA",
  133: "PA", 134: "MT", 135: "PA", 136: "GO", 137: "MA", 138: "PA", 139: "MS", 140: "MT",
  141: "PA", 142: "GO", 143: "PA", 144: "PA", 145: "PA", 146: "GO", 147: "PA", 148: "PA",
  149: "PA", 150: "PA", 151: "MT", 152: "MT", 153: "MA", 154: "GO", 155: "PA", 156: "PA",
  157: "PA", 158: "MA", 159: "RO", 160: "SP", 161: "DF", 162: "BA", 163: "BA", 164: "BA",
  165: "GO", 167: "PE", 168: "PI", 169: "DF", 170: "GO", 171: "GO", 172: "PA", 173: "BA",
  174: "BA", 175: "MA", 176: "BA", 177: "BA", 178: "PA", 179: "SP", 180: "AC", 181: "BA",
  182: "BA", 183: "MA", 184: "PE", 185: "BA", 186: "PA", 187: "PE", 188: "PE", 189: "PE",
  190: "PE", 191: "PE", 192: "PE", 193: "PA", 194: "BA", 195: "BA", 196: "PA", 197: "SE",
  198: "PE", 199: "SE", 200: "MT", 201: "PE", 202: "MS", 204: "AL", 205: "PE", 206: "CE",
  207: "RO", 208: "CE", 209: "RO", 210: "PE", 211: "PE", 213: "PA", 214: "PE", 216: "MG",
  217: "MS", 221: "MT", 223: "BA", 224: "PA", 500: "MS", 501: "SP", 502: "MT", 503: "MS",
  504: "SP", 505: "SP", 506: "SP", 508: "TO", 513: "MT", 995: "MT", 999: "MT"
} as const;

export const situacaoMap: Record<number, string> = {
  0: "Pendente",
  2: "Sucesso",
  3: "Contingência",
  9: "Cancelado",
};

export const situacaoColors: Record<string, string> = {
  Sucesso: "#2563eb", // azul mais profissional
  Contingência: "#f97316", // laranja mais suave
  Pendente: "#eab308", // amarelo mais suave
  Cancelado: "#94a3b8", // cinza mais suave
};

// Tipo para as UFs disponíveis
export type StoreUF = (typeof storeUFMap)[keyof typeof storeUFMap];